import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/pages/home/index'),
      meta:{
        active:'/'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('@/pages/search/search'),
      meta:{
        active:'/'
      }
    },
    {
      path: '/goods',
      name: 'goods',
      component: () => import('@/pages/goods/list'),
      meta:{
        active:'goods'
      }
    },
    {
      path: '/goods/detail',
      name: 'detail',
      component: () => import('@/pages/goods/detail'),
      meta:{
        active:'goods'
      }
    },
    {
      path: '/business',
      name: 'business',
      component: () => import('@/pages/business/index'),
      meta:{
        active:'goods'
      }
    },
    {
      path: '/business/detail',
      name: 'businessDetail',
      component: () => import('@/pages/business/detail'),
      meta:{
        active:'goods'
      }
    },
    {
      path: '/release',
      name: 'release',
      component: () => import('@/pages/release/release'),
    },
    {
      path: '/run',
      name: 'run',
      component: () => import('@/pages/release/run'),
    },
    {
      path: '/msg',
      name: 'msg',
      component: () => import('@/pages/message/index'),
      meta:{
        active:'msg'
      }
    },
    {
      path: '/msg/detail',
      name: 'msgDetail',
      component: () => import('@/pages/message/detail'),
      meta:{
        active:'msg'
      }
    },
    {
      path: '/active',
      name: 'active',
      component: () => import('@/pages/active/list'),
      meta:{
        active:'active'
      }
    },
    {
      path: '/active1',
      name: 'active1',
      component: () => import('@/pages/active/active1'),
      meta:{
        active:'active'
      }
    },
    {
      path: '/active2',
      name: 'active2',
      component: () => import('@/pages/active/active2'),
      meta:{
        active:'active'
      }
    },
    {
      path: '/active3',
      name: 'active3',
      component: () => import('@/pages/active/active3'),
      meta:{
        active:'active'
      }
    },
    {
      path: '/active4',
      name: 'active4',
      component: () => import('@/pages/active/active4'),
      meta:{
        active:'active'
      }
    },
    {
      path: '/member',
      name: 'member',
      component: () => import('@/pages/member/member'),
      meta:{
        active:'member'
      }
    },
    {
      path: '/demand',
      name: 'demand',
      component: () => import('@/pages/member/demand'),
      meta:{
        active:'member'
      }
    },
    {
      path: '/member/business',
      name: 'memberBusiness',
      component: () => import('@/pages/member/business'),
      meta:{
        active:'memberBusiness'
      }
    },
    {
      path: '/member/evaluate',
      name: 'evaluate',
      component: () => import('@/pages/member/evaluate'),
      meta:{
        active:'evaluate'
      }
    },
    {
      path: '/member/score',
      name: 'score',
      component: () => import('@/pages/member/score'),
      meta:{
        active:'score'
      }
    }
    ,
    {
      path: '/member/coin',
      name: 'coin',
      component: () => import('@/pages/member/coin'),
      meta:{
        active:'coin'
      }
    },
    {
      path: '/member/collect',
      name: 'collect',
      component: () => import('@/pages/member/collect'),
      meta:{
        active:'collect'
      }
    },
    {
      path: '/member/news',
      name: 'news',
      component: () => import('@/pages/member/news'),
      meta:{
        active:'news'
      }
    },
    {
      path: '/member/auth',
      name: 'auth',
      component: () => import('@/pages/member/auth'),
      meta:{
        active:'auth'
      }
    },
    {
      path: '/member/auth_success',
      name: 'auth_success',
      component: () => import('@/pages/member/auth_success'),
      meta:{
        active:'auth'
      }
    },
    {
      path: '/member/set',
      name: 'set',
      component: () => import('@/pages/member/set'),
      meta:{
        active:'set'
      }
    },
    {
      path: '/shop',
      name: 'shop',
      component: () => import('@/pages/shop/list'),
    },
    {
      path: '/shop/detail',
      name: 'shopDetail',
      component: () => import('@/pages/shop/detail'),
    },
    {
      path: '/shop/form',
      name: 'form',
      // component: () => import('@/pages/shop/form'),
      component: () => import('@/pages/shop/formNew'),
    },
    {
      path: '/shop/record/detail',
      name: 'recordDetail',
      component: () => import('@/pages/shop/record_detail'),
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: () => import('@/components/agreement'),
    },
    {
      path: '/feedBack',
      name: 'feedBack',
      component: () => import('@/pages/member/feedBack'),
    },
    {
      path: '/member/change',
      name: 'change',
      component: () => import('@/pages/member/change'),
      meta:{
        active:'auth'
      }
    },
    {
      path: '/business/edit',
      name: 'businessEdit',
      component: () => import('@/pages/business/edit'),
      meta:{
        active:'memberBusiness'
      }
    },
    {
      path: '/business/examine',
      name: 'examine',
      component: () => import('@/pages/business/examine'),
      meta:{
        active:'memberBusiness'
      }
    },
    {
      path: '/business/comment',
      name: 'businessComment',
      component: () => import('@/pages/business/comment'),
      meta:{
        active:'memberBusiness'
      }
    },
    {
      path: '/location',
      name: 'location',
      component: () => import('@/pages/home/location'),
      meta:{
        active:'/'
      }
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('@/pages/help/index'),
    },
    {
      path: '/help/detail',
      name: 'helpDetail',
      component: () => import('@/pages/help/detail'),
    },
    {
      path: '/home/app',
      name: 'homeApp',
      component: () => import('@/pages/home/app'),
    },
    {
      path: '/message_center',
      name: 'message_center',
      component: () => import('@/pages/message_center/index'),
    },
    {
      path: '/sharewx',
      name: 'sharewx',
      component: () => import('@/components/share'),
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: () => import('@/pages/member/cooperation'),
    },
    {
      path: '/frozen_detail',
      name: 'frozen_detail',
      component: () => import('@/pages/frozen/frozen_detail'),
    },
    {
      path: '/system_message',
      name: 'system_message',
      component: () => import('@/pages/system_message/system_list'),
    },
    {
      path: '/message_detail',
      name: 'message_detail',
      component: () => import('@/pages/system_message/system_detail'),
    },

		// 2024-06-16 新增路由
		{
      path: '/topUpGold',
      name: 'topUpGold',
      component: () => import('@/pages/member/topUpGold.vue'),
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js